import { render } from "./ProjectSubmit.vue?vue&type=template&id=528c984f&scoped=true"
import script from "./ProjectSubmit.vue?vue&type=script&lang=js"
export * from "./ProjectSubmit.vue?vue&type=script&lang=js"

import "./ProjectSubmit.vue?vue&type=style&index=0&id=528c984f&lang=scss&scoped=true"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528c984f"]])

export default __exports__